import {CPU_SHARE_LIMIT} from './longTaskMonitor';
import type {ReliefReason, ReliefSample} from './videoReliefAdvisor';

export interface ReliefEvidence {
    readonly networkDegraded: boolean;
    readonly networkGood: boolean;
    readonly cpuLimited: boolean;
    readonly cpuShare?: number;
}

export const toReliefSample = (evidence: ReliefEvidence, videoActive: boolean): ReliefSample => {
    const cpuBusy = evidence.cpuLimited || (evidence.cpuShare ?? 0) > CPU_SHARE_LIMIT;
    const degraded: ReliefReason | null = evidence.networkDegraded ? 'network' : cpuBusy ? 'cpu' : null;
    return {degraded, healthy: evidence.networkGood && !degraded, videoActive};
};

export const NO_EVIDENCE: ReliefEvidence = {networkDegraded: false, networkGood: false, cpuLimited: false};

const GOOD_QUALITY = new Set(['good', 'excellent']);
const POOR_QUALITY = new Set(['poor', 'lost']);

export interface SenderStatsLike {
    readonly qualityLimitationReason?: string;
}

export const groupEvidence = (
    quality: string | undefined,
    senderStats: readonly SenderStatsLike[],
    paused: boolean,
    cpuShare: number | undefined,
): ReliefEvidence => {
    const reasons = paused ? [] : senderStats.map(stats => stats.qualityLimitationReason);
    return {
        networkDegraded: (quality !== undefined && POOR_QUALITY.has(quality)) || reasons.includes('bandwidth'),
        networkGood: quality !== undefined && GOOD_QUALITY.has(quality),
        cpuLimited: reasons.includes('cpu'),
        cpuShare,
    };
};
